import { uaInfo } from './system';

export const DOMAIN_URL = 'https://www.talkiex.com';

// const regex = /[^A-Za-z0-9\-_]/g;

export const onGoBack = (defaultUrl: string, onClick?: (e: any) => void) => {
  return (e: any) => {
    // SEO 目的，搜索引擎不做 SPA 而是直接跳转 defaultUrl，正常用户还是 SPA
    if (!uaInfo.IsSearchEngine) {
      e.preventDefault();
      e.stopPropagation();
      onClick?.(e);
      // 有历史记录则返回上一页，否则直接跳转 defaultUrl
      if (window.history.length > 1) {
        window.history.back();
      } else {
        location.href = defaultUrl;
      }
    }
  };
};

// 多语言的url，空格全部替换成-，字母全部小写，剔除掉特殊符号
function generateSlug(text: string) {
  try {
    return (
      text
        // 替换空格为-
        .replace(/\s+/g, '-')
        // 剔除特殊符号
        .replace(/[:\\|\\"<>\\/?.,!@#$%^&*()+={}\\[\];'`~]/g, '')
        // 转换为小写
        .toLowerCase()
        // 对非英语字符进行转义
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
    );
  } catch (e) {
    console.error('url generateSlug error:', e);
    return '';
  }
}

export const getParamId = (paramString: string | undefined): number => {
  const isNameAndId = paramString?.includes('-');
  if (isNameAndId) {
    return Number(paramString?.split('-').pop()) || 0;
  }
  return Number(paramString) || 0;
};

const getPathUrl = (prefix: string, id?: number, name?: string) => {
  if (id === undefined) return prefix;
  if (!name) return `${prefix}/${id}`;
  // 空格用 - 替换，转小写，去除特殊字符
  const tagName = generateSlug(name);
  if (!tagName) return `${prefix}/${id}`;
  return `${prefix}/${tagName}-${id}`;
};

export const getEditPageUrl = ({
  npcId,
  materialId,
  materialImgUrl,
}: {
  npcId?: number | string;
  materialId?: number;
  materialImgUrl?: string;
} = {}) => {
  const params = new URLSearchParams();
  if (npcId) params.set('npc_id', npcId.toString());
  if (materialId) params.set('material_id', materialId.toString());
  if (materialImgUrl) params.set('material_img_url', materialImgUrl);
  if (params.size > 0) return `/create/edit?${params.toString()}`;
  return '/create/edit';
};

export const getFmCreationPageUrl = ({
  fmDraftId,
  materialId,
  materialImgUrl,
}: {
  fmDraftId?: string;
  materialId?: number;
  materialImgUrl?: string;
}) => {
  const params = new URLSearchParams();
  if (fmDraftId) params.set('fm_draft_id', fmDraftId);
  if (materialId) params.set('material_id', materialId.toString());
  if (materialImgUrl) params.set('material_img_url', materialImgUrl);
  return `/create/fm/creation?${params.toString()}`;
};

export const getImageCreationPageUrl = ({
  npcId,
  materialId,
  fmDraftId,
  from,
  action,
}: {
  npcId?: number | string;
  materialId?: number;
  fmDraftId?: number;
  from?: 'fm_creation';
  action?: 'inpaint' | 'recreate';
} = {}) => {
  const params = new URLSearchParams();
  if (npcId) params.set('npc_id', npcId.toString());
  if (materialId) params.set('material_id', materialId.toString());
  if (action) params.set('action', action);
  if (fmDraftId) params.set('fm_draft_id', fmDraftId.toString());
  if (from) params.set('from', from);
  if (params.size > 0) return `/create/image/creation?${params.toString()}`;
  return '/create/image/creation';
};
